var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-notification error"},_vm._l((_vm.errors),function(error){return _c('p',{key:error,domProps:{"innerHTML":_vm._s(_vm.formatError(error))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }